import { API_URL, is_dev_env } from "../Util/constant";

export async function makeGetApiRequest(path) {
    try {
        const response = await fetch(`${API_URL}${path}`, {
            headers: { Authorization: localStorage.getItem("user_access_token") },
        });
        if (response.status === 401 && !is_dev_env) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";
        }
        let ret_data = await response.json();
        return ret_data;
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}

export async function makeApiRequest(path, params) {
    try {
        var reqHeader = new Headers();
        reqHeader.append(
            "Authorization",
            localStorage.getItem("user_access_token")
        );
        reqHeader.append("Content-Type", "application/json");
        const response = await fetch(`${API_URL}${path}`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: reqHeader,
            // mode:'no-cors',
            redirect: "follow",
        });
        if (response.status === 401 && !is_dev_env) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        const rresponse = await response.json();
        if (!rresponse.error) {
            return { result: rresponse };
        } else {
            // TODO HAVE TO ASK BACKEND when will it return error->data
            return { error: rresponse.error.data || rresponse.error };
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}
//V1 - Get Packages
export async function GetDashboard() {
    const response = await makeGetApiRequest("/users/getdashboard");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//--------------------------------------------------------------Online Store -------------------------------------------------------------------
//V1 - Get Packages
export async function GetPackages() {
    const response = await makeGetApiRequest("/users/packages/getpackages");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//V1 - Buy Package

export async function BuyPackage(set_values) {
    const response = await makeApiRequest(
        "/users/packages/subscribeplan",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//V1 - Get Package Percenetage

export async function GetPackagePercentage(set_values) {
    const response = await makeApiRequest(   "/users/packages/getpackagepercentage",  set_values  );
    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//V1-Get Package Subscription

export async function GetUserPackageSubscription(set_values) {
    const response = await makeApiRequest(
        "/users/packages/getpackagesubscriptions",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//V1-Get SubScription Cash Wallet or daily rewards

export async function GetDailyRewards(set_values) {
    const response = await makeApiRequest(
        "/users/rewards/getdailyrewards",
        set_values
    );
    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//-------------------------------------------------------------- Profile -------------------------------------------------------------------

// v1-Add Profile

export async function AddProfile(values) {
    const formData = new FormData();
    formData.append("full_name", values.full_name);
    formData.append("mobile_no", values.mobile_no);
    formData.append("country", values.country);
    formData.append("city", values.city);
    formData.append("pincode", values.pincode);
    formData.append("dob", values.dob);
    formData.append("address", values.address);
    formData.append("profile_logo", values.profile_logo);

    try {
        var reqHeader = new Headers();
        reqHeader.append(
            "Authorization",
            localStorage.getItem("user_access_token")
        );
        const response = await fetch(`${API_URL}/users/addprofile`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            // mode:'no-cors',
            redirect: "follow",
        });
        if (response.status === 401) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        const rresponse = await response.json();
        if (!rresponse.error) {
            return rresponse;
        } else {
            return { error: rresponse.error.data };
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}
//V1 - Get Profile
export async function GetProfile() {
    const response = await makeGetApiRequest("/users/getuser");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//--------------------------------------------------------Wallet-----------------------------------------------------------------
//V1-Get Deposit Wallet

export async function GetDepositWallet(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/getdepositwallet",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//V1-Get Cash Wallet

export async function GetCashWallet(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/getcashwallet",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//V1-Get Income Wallet

export async function GetIncomeWallet(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/getincomewallet",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//V1-Get GetQuantumWallet

export async function GetQuantumWallet(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/getquantumwallet",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//----------------------------------------------------------DEPOSIT & TRANSACTION (DEPOSIT T0 WALLET)---------------------------------------------------------

//V1 - Add Deposit Crypto Request

export async function MakeDepositCryptoRequest(set_values) {
    const response = await makeApiRequest(
        "/crypto/createdepositrequest",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//V1-Get Crypto Transaction
export async function GetCryptoTransaction(set_values) {
    const response = await makeApiRequest(
        "/crypto/getcryptotransactions",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//----------------------------------------------------------DEPOSIT & TRANSACTION (FUND TRANSFER)---------------------------------------------------------

//V1 - Fund Transfer Request
export async function TransferFundRequest(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/transferfunds",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//V1 - Verify Transfer Request
export async function VerifyTransferRequest(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/verifytransfers",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//V1 - Get Wallet Transection
export async function GetWalletTransections(set_values) {
    const response = await makeApiRequest(
        "/users/wallet/getwallettransactions",
        set_values
    );
    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//---------------------------------------------------User KYC --------------------------------------------------------------

//V1 - Get User KYC
export async function GetUserKYC() {
    const response = await makeGetApiRequest("/users/getuserkyc");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//Get User KYC Log
export async function GetUserKYCLog(set_values) {
    const response = await makeApiRequest("/users/getkyclogs", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

export async function GetNewUserKYC() {
    const response = await makeGetApiRequest("/users/getuserkycs");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

export async function UpdateKYCDocument(values) {
    const formData = new FormData();
    formData.append("kyc_type", values.kyc_type);
    formData.append("document_name", values.document_name);
    formData.append("kyc_docs", values.kyc_docs);

    // Conditionally append fields based on kyc_type
    if (values.kyc_type === "ID") {
        formData.append("document_number", values.document_number);
        formData.append("expiry_date", values.expiry_date);
    }

    try {
        var reqHeader = new Headers();
        reqHeader.append(
            "Authorization",
            localStorage.getItem("user_access_token")
        );
        const response = await fetch(`${API_URL}/users/uploadkycdocument`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            redirect: "follow",
        });
        if (response.status === 401) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        const rresponse = await response.json();
        if (!rresponse.error) {
            return rresponse;
        } else {
            return { error: rresponse.error.data };
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}

export async function AddUserKYC(values) {
    const formData = new FormData();

    // Append common fields
    formData.append("id_document_name", values.id_document_name);
    formData.append("id_document_number", values.id_document_number);
    formData.append("id_expiry_date", values.id_expiry_date);
    formData.append("address_document_name", values.address_document_name);
    formData.append("kyc_id", values.kyc_id);
    formData.append("kyc_id2", values.kyc_id2);
    formData.append("kyc_address", values.kyc_address);
    formData.append("kyc_address2", values.kyc_address2);

    try {
        // Create headers
        var reqHeader = new Headers();
        reqHeader.append("Authorization", localStorage.getItem("user_access_token"));

        // API call
        const response = await fetch(`${API_URL}/users/adduserkyc`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            redirect: "follow",
        });

        // Handle Unauthorized Error (401)
        if (response.status === 401) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }

        // Parse response
        const rresponse = await response.json();
        if (!rresponse.error) {
            return rresponse; // Successful response
        } else {
            return { error: rresponse.error.data }; // API returned an error
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "API Request Error",
                message: "There was an issue with the API request",
                error: error,
            },
        };
    }
}

export async function UpdateUserKYC(values) {
    console.log("values", values); // Log the entire values object to inspect its content
    const formData = new FormData();
    formData.append("user_kyc_id", values.user_kyc_id);
    // Append fields for updating KYC if id_status is "rejected" or "pending"
    if (values?.id_status === "rejected" || values?.id_status === "pending") {
        console.log("ID Document Fields are being appended.");
        formData.append("id_document_name", values.DocumentName);
        formData.append("id_document_number", values.DocumentNumber);
        formData.append("id_expiry_date", values.expiryDate);
        formData.append("kyc_id", values.kyc_id); // File for ID document
        formData.append("kyc_id2", values.kyc_id2); // File for ID document
    }
    // Append fields for address status if "rejected" or "pending"
    if (values?.address_status === "rejected" || values?.address_status === "pending") {
        console.log("Address Fields are being appended.");
        formData.append("address_document_name", values.DocumentNameForAddress);
        formData.append("kyc_address", values.kyc_address); // File for address document
        formData.append("kyc_address2", values.kyc_address2); // File for address document
    }
    try {
        // Create headers
        const reqHeader = new Headers();
        reqHeader.append("Authorization", localStorage.getItem("user_access_token"));
        // API call
        const response = await fetch(`${API_URL}/users/updateuserkyc`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            redirect: "follow",
        });
        // Handle Unauthorized Error (401)
        if (response.status === 401) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        // Parse response
        const rresponse = await response.json();
        if (!rresponse.error) {
            return rresponse; // Successful response
        } else {
            return { error: rresponse.error.data }; // API returned an error
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "API Request Error",
                message: "There was an issue with the API request",
                error: error,
            },
        };
    }
}


//-------------------------------------------------------- My Team ---------------------------------------
//V1- Get Team

export async function GetTeamMembers(set_values) {
    const response = await makeApiRequest(
        "/users/teams/getteammembers",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get Visual Structure Data
export async function GetVisualData() {
    const response = await makeGetApiRequest("/users/teams/getvisualdata");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//-----------------------------------------------------------Rank----------------------------------------------------------------------

//Get Team Rank Data
export async function GetRankData() {
    const response = await makeGetApiRequest("/users/ranks/getrankdata");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get Club Rank Data
export async function GetClubRankData() {
    const response = await makeGetApiRequest("/users/ranks/getclubrankdata");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get Level Rank Data
export async function GetLevelRankData() {
    const response = await makeGetApiRequest("/users/ranks/getlevelrankdata");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//Get Rewards Data
export async function GetRewardsData() {
    const response = await makeGetApiRequest("/users/ranks/getrewardsdata");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//-----------------------------------------------------------Security----------------------------------------------------------------------

//Update Non Spamkey
export async function UpdateSpamKey(set_values) {
    const response = await makeApiRequest("/users/updatenonspamkey", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get Transection Password OTP
export async function GetTransactionPasswordOTP() {
    const response = await makeGetApiRequest("/users/sendtranscationpasswordotp");
    if (response.data || response.status) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Update Transection Password
export async function UpdateTransactionPassword(set_values) {
    const response = await makeApiRequest(
        "/users/updatetransactionpassword",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Update Login Password
export async function UpdateLoginPassword(set_values) {
    const response = await makeApiRequest(
        "/users/updateloginpassword",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Toggle White List
export async function ToggleWhiteListEnable(set_values) {
    const response = await makeApiRequest("/users/togglewhitelist", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Add White List
export async function AddWhiteList(set_values) {
    const response = await makeApiRequest("/users/addtowhitelist", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Remove White List
export async function RemoveWhiteList(set_values) {
    const response = await makeApiRequest(
        "/users/removefromwhitelist",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Toggle Two Factore Authantication
export async function ToggleTwoFAEnable(set_values) {
    const response = await makeApiRequest("/users/toggletwofa", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get White List IPS
export async function GetWhiteListIP() {
    const response = await makeGetApiRequest("/users/getwhitelistips");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//---------------------------------------------------------------- Withdrawal --------------------------------------------------

export async function GetWithdrawalWallets() {
    const response = await makeGetApiRequest("/crypto/getcryptowalletaddress");
    if (response.data || response.status) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

export async function CancelWithdrawal(set_values) {
    const response = await makeApiRequest(
        "/crypto/cancelwithdrawal",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

export async function MakeWithdrawalRequest(set_values) {
    const response = await makeApiRequest(
        "/crypto/createwithdrawalrequest",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//delete row in withdrawal setting
export async function deleteWalletAddress(set_values) {
    const response = await makeApiRequest(
        "/crypto/deletecryptowalletaddress",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//Get  withdrwal data
export async function GetWithdrawalsData(set_values) {
    const response = await makeApiRequest("/crypto/getwithdrawals", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//v1-Set Crypto Wallet Adress
export async function setCryptowalletAddress(set_values) {
    const response = await makeApiRequest(
        "/crypto/setcryptowalletaddress",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//----------------------------------------------------------------Support And Chat ------------------------------------

export async function createTicket({
    ticket_type,
    priority,
    subject,
    description,
    file,
}) {
    const formData = new FormData();
    formData.append("ticket_type", ticket_type);
    formData.append("priority", priority);
    formData.append("subject", subject);
    formData.append("description", description);

    if (file) {
        formData.append("tickets", file);
    }

    try {
        const headers = new Headers();
        headers.append("Authorization", localStorage.getItem("user_access_token")); // Authorization token from local storage

        const response = await fetch(`${API_URL}/users/tickets/createticket`, {
            method: "POST",
            headers: headers,
            body: formData,
            redirect: "follow",
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error creating ticket:", error);
        return {
            error: {
                title: "Request Failed",
                message: "Unable to create ticket. Please try again later.",
                details: error.message,
            },
        };
    }
}

export async function addSupportChat(values) {
    const formData = new FormData();
    formData.append("ticket_id", values.ticket_id);
    formData.append("message", values.message);

    // Append file if it's selected
    if (values.chat_file) {
        formData.append("chat_file", values.chat_file);
    }

    try {
        const reqHeader = new Headers();
        reqHeader.append(
            "Authorization",
            localStorage.getItem("user_access_token")
        );
        const response = await fetch(`${API_URL}/users/tickets/addsupportchat`, {
            method: "POST",
            body: formData,
            headers: reqHeader,
            redirect: "follow",
        });

        if (response.status === 401) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

            return;
        }

        const result = await response.json();
        if (!result.error) {
            return result;
        } else {
            return { error: result.error };
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "API request error",
                message: "There was an error with the API request.",
                error: error,
            },
        };
    }
}

export async function GetTicketChat(set_values) {
    const response = await makeApiRequest(
        "/users/tickets/getticketchat",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//----------------------------------------------------------------Network Rewards------------------------------------

//V1- Get Network Rewards

export async function GetNetworkRewards(set_values) {
    const response = await makeApiRequest(
        "/users/rewards/getnetworkrewards",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//Get Network Reward By Level
export async function GetNetworkRewardByLevel(set_values) {
    const response = await makeApiRequest(
        "/users/rewards/getnetworkrewardsbylevels",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//---------------------------------------------------------Suport Ticket ----------------------------------------------------------

//V1 -Get User Tickets
export async function GetUserTickets() {
    const response = await makeGetApiRequest("/users/tickets/getusertickets");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//--------------------------------------------------------- All Activity ----------------------------------------------------------
//V1- Get Activities
export async function GetAllActivites(set_values) {
    const response = await makeApiRequest("/users/getallactivities", set_values);

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

//--------------------------------------------------------- Document ----------------------------------------------------------

//V1 -Get Documents
export async function GetDocuments() {
    const response = await makeGetApiRequest("/users/getdocuments");
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
// Get Business Info
export async function GetBusinessInfo(set_values) {
    const response = await makeApiRequest(
        "/users/teams/getbusinessinfo",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// Get Member name
export async function getNameFromMemberId(member_id) {
    const response = await makeApiRequest(
        "/auth/getsponserusername",
        { member_id }
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
// Get Member Info
export async function GetMemberInfo(member_id) {
    const response = await makeApiRequest(  "/users/getmemberinfo", { member_id } );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
//----------------------------------------------------------AVFX WALLET -----------------------------------------------
// UPDATE AVFX PERCENTAGE
export async function UpdateAVFXPercentage(payload) {
    const response = await makeApiRequest( "/users/avfx/updateavfxpercent",  payload );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// ADD FUNDS TO AVFX WALLET
export async function AddFundsToAVFXWallet(payload) {
    const response = await makeApiRequest( "/users/avfx/addfundstoavfxwallet",  payload );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// GET AVFX WALLET 
export async function GetAVFXWallet(payload) {
    const response = await makeApiRequest( "/users/avfx/getavfxwallet",  payload );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// CONNECT AVFX ACCOUNT
export async function ConnectAVFXAccount(payload) {
    const response = await makeGetApiRequest( "/users/avfx/connectavfx",  payload );

   if (response) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}
// SEND AVFX AMOUNT
export async function SendAVFXAmount() {
    const response = await makeGetApiRequest("/users/avfx/sendavfxamount");
    if (response) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}